module.exports = __webpack_public_path__ + "media/images/home/mapa_sp-075821364b1e0b4b8b71672e4d4de4ff.png";